import { InfoBox } from '@selina-finance/ui';

import { BUILDING_IDENTIFIER_ERROR_MESSAGE } from '@src/shared/constants';

interface IAddressErrorInfoBoxProps {
    saveAddressError: string;
    shouldShowBuildingIdentifierError: boolean;
    shouldShowSaveAddressError: boolean;
}

export const AddressErrorInfoBox = ({
    saveAddressError,
    shouldShowBuildingIdentifierError,
    shouldShowSaveAddressError,
}: IAddressErrorInfoBoxProps) => {
    const getAddressErrorMessage = (): string | null => {
        if (shouldShowBuildingIdentifierError) {
            return BUILDING_IDENTIFIER_ERROR_MESSAGE;
        }

        if (shouldShowSaveAddressError) {
            return saveAddressError;
        }

        return null;
    };
    const addressErrorMessage = getAddressErrorMessage();

    return (
        <>
            {addressErrorMessage && (
                <InfoBox className='mt-4 border-none' type='error'>
                    {addressErrorMessage}
                </InfoBox>
            )}
        </>
    );
};
